import React from "react";
// import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import {
  HashRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FrontendPrivateRoute from "./components/admin/common/FrontendPrivateRoute";
import { isTokenExpired } from "./utils/authUtils";
import NotFound from "./pages/errors/NotFound";
import Forbidden from "./pages/errors/Forbidden";
import ServerError from "./pages/errors/ServerError";
import "@fortawesome/fontawesome-free/css/all.min.css";
import HomePage from "./pages/frontend/HomePage";
import LoginRegister from "./pages/frontend/LoginRegister";
import Profile from "./pages/frontend/User/Profile";
import UserChangePassword from "./pages/frontend/User/ChangePassword";
import MyLands from "./pages/frontend/User/MyLands";
import Activities from "./pages/frontend/User/Activities";
import Step1 from "./pages/frontend/User/PostLand/PostLand";
import UserEnquiries from "./pages/frontend/User/UserEnquiries";
import EditLand from "./pages/frontend/User/PostLand/EditLand";
import LandView from "./pages/frontend/User/LandView";
import LandList from "./pages/frontend/LandList";
import PublicLandView from "./pages/frontend/PublicLandView";
import Blogs from "./pages/frontend/Blogs";
import BlogDetail from "./pages/frontend/BlogDetail";
import About from "./pages/frontend/About";
import Contact from "./pages/frontend/Contact";
import UserDashboard from "./pages/frontend/User/UserDashboard";
import ScrollToTop from "./components/ScrollToTop";
import Faq from "./pages/frontend/Faq";
import PrivacyPolicy from "./pages/frontend/PrivacyPolicy";
import TermsandCondition from "./pages/frontend/TermsandCondition";
import Disclaimer from "./pages/frontend/Disclaimer";

function App() {
  return (
    <Router>
      <ToastContainer position="top-right" autoClose={3000} />
      <ScrollToTop />
      <Routes>
        {/* Start Error pages routes */}
        <Route path="/403" element={<Forbidden />} />
        <Route path="/500" element={<ServerError />} />
        <Route path="*" element={<NotFound />} />
        {/* End Error pages routes */}

        {/* Front end routes */}
        <Route path="/" element={<HomePage />} />
        <Route path="/authuser/login" element={<LoginRegister />} />
        <Route path="/lands" element={<LandList />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/blogs/:seourl" element={<BlogDetail />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/faqs" element={<Faq />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsandCondition />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/disclaimer" element={<Disclaimer />} />
        <Route path="/:id" element={<PublicLandView />} />
        <Route
          path="/authuser/dashboard"
          element={
            <FrontendPrivateRoute>
              <UserDashboard />
            </FrontendPrivateRoute>
          }
        />
        <Route
          path="/authuser/profile"
          element={
            <FrontendPrivateRoute>
              <Profile />
            </FrontendPrivateRoute>
          }
        />
        <Route
          path="/authuser/change-password"
          element={
            <FrontendPrivateRoute>
              <UserChangePassword />
            </FrontendPrivateRoute>
          }
        />
        <Route
          path="/authuser/My-Lands"
          element={
            <FrontendPrivateRoute>
              <MyLands />
            </FrontendPrivateRoute>
          }
        />
        <Route
          path="/authuser/activities"
          element={
            <FrontendPrivateRoute>
              <Activities />
            </FrontendPrivateRoute>
          }
        />
        <Route
          path="/authuser/Post-Land"
          element={
            <FrontendPrivateRoute>
              <Step1 />
            </FrontendPrivateRoute>
          }
        />
        <Route
          path="/authuser/Edit-Land/:id"
          element={
            <FrontendPrivateRoute>
              <EditLand />
            </FrontendPrivateRoute>
          }
        />
        <Route
          path="/authuser/View-Land/:id"
          element={
            <FrontendPrivateRoute>
              <LandView />
            </FrontendPrivateRoute>
          }
        />
        <Route
          path="/authuser/enquiries"
          element={
            <FrontendPrivateRoute>
              <UserEnquiries />
            </FrontendPrivateRoute>
          }
        />
        {/* end front end routes */}
      </Routes>
    </Router>
  );
}

export default App;
